import { defineComponent as _defineComponent } from 'vue'
import SwitchComponent from "@/components/ui/SwitchComponent.vue";
  import LotLifecycle from "@/components/LotLifecycle.vue";
  import { onMounted, ref, computed } from "vue";
  import router from "@/router";
  import store from "@/store";
  import { UserInterface } from "@/types/UserInterface";
  import { EstateInterface } from "@/types/EstateInterface";
  import { StageInterface } from "@/types/StageInterface";
  import { getLotStatusClass } from "@/helpers/status";
  import { UserRoles } from "@/enums/UserRoles";
  import { getFirstLastName } from "@/helpers/user";
  import { LotDocument, LotInterface } from "@/types/LotInterface";
  import { canEditLot } from "@/helpers/lot/adminLot";
  import { LotStatus } from "@/enums/LotStatus";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLot',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const stageId = router.currentRoute.value.params.stageId;
  const lotId = router.currentRoute.value.params.lotId;
  const user = ref<UserInterface | null>(null);
  const estate = ref<EstateInterface | null>(null);
  const stage = ref<StageInterface | null>(null);
  const lot = ref<LotInterface | null>(null);
  const tabs = [{ label: "documents" }, { label: "map" }];
  const currentTab = ref(
    tabs.find((label) =>
      router.currentRoute.value.fullPath.includes(label.label)
    )
  );

  function toTab(tab: string) {
    if (currentTab.value.label !== tab) {
      router.push(
        router.currentRoute.value.fullPath.replace(currentTab.value.label, tab)
      );
    }
  }

  const getLotStatus = computed(() => {
    if (lot.value && lot.value.status) {
      if (lot.value.status === LotStatus.EOI) {
        return LotStatus.PRE_CONTRACT;
      }

      return lot.value.status;
    }

    return "";
  });

  onMounted(() => {
    store.dispatch("user/getUser", userId).then((res) => {
      user.value = res.data;
    });
    store.dispatch("estate/getEstate", estateId).then((res) => {
      estate.value = res.data;
    });
    store.dispatch("stage/getStage", stageId).then((res) => {
      stage.value = res.data;
    });
    getLot();
  });

  function getLot() {
    store.dispatch("lot/getLot", lotId).then((res) => {
      lot.value = res.data;
    });
  }
  function addDocument(document: {
    file: LotDocument;
    documentType: "contracts" | "documents";
  }) {
    lot.value[document.documentType].unshift(document.file);
  }
  function deleteDocument(document: {
    index: number;
    documentType: "contracts" | "documents";
  }) {
    lot.value[document.documentType].splice(document.index, 1);
  }

const __returned__ = { userId, estateId, stageId, lotId, user, estate, stage, lot, tabs, currentTab, toTab, getLotStatus, getLot, addDocument, deleteDocument, SwitchComponent, LotLifecycle, onMounted, ref, computed, get router() { return router }, get store() { return store }, get UserInterface() { return UserInterface }, get EstateInterface() { return EstateInterface }, get StageInterface() { return StageInterface }, get getLotStatusClass() { return getLotStatusClass }, get UserRoles() { return UserRoles }, get getFirstLastName() { return getFirstLastName }, get LotDocument() { return LotDocument }, get LotInterface() { return LotInterface }, get canEditLot() { return canEditLot }, get LotStatus() { return LotStatus } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})